import React from 'react'
import styled from '@emotion/styled'
import { array, bool, object, string } from 'prop-types'

//components import
import { Layout, SearchForm } from '@jelly/components'
import HeroBanner from 'components/HeroBanner'
import CoreOfferings from './CoreOfferings'
import Methodology from './Methodology'
import ReviewCards from './ReviewCards'
import Testimonials from './Testimonials'
import PriceQuotes from './PriceQuotes'
import AdditionalTools from './AdditionalTools'

const ReviewPageWrapper = styled.div`
	height: 100%;
	width: 100%;
`
const HeroTextStyles = `
    color: #FFF;
`

const ReviewBannerTitle = styled.h1`
	${HeroTextStyles};
	font-size: 22px;
	padding-top: 20px;
	padding-bottom: 5px;
	margin: 0;
	${({ theme }) => theme.MQ.M} {
		${({ theme }) => theme.header.h1};
		width: 100%;
	}
`
const ReviewBannerText = styled.div`
	${HeroTextStyles};
	font-size: 15px;
	max-width: 65%;
	padding-bottom: 20px;
	${({ theme }) => theme.MQ.M} {
		${({ theme }) => theme.header.h2};
		font-weight: 100;
		max-width: 700px;
	}
`
const OfferingsMethhWrapper = styled.div`
	display: flex;
	flex-direction: column;

	${({ theme }) => theme.MQ.M} {
		display: flex;
		flex-direction: row;
	}
`
ReviewPage.propTypes = {
	additionalTools: object.isRequired,
	articles: array.isRequired,
	backgroundImage: string.isRequired,
	coreOfferings: array.isRequired,
	hasVwo: bool,
	meta: object.isRequired,
	methodology: object.isRequired,
	priceQuotes: object.isRequired,
	categories: array.isRequired,
	subtitle: string.isRequired,
	testimonials: object.isRequired,
	title: string.isRequired,
}
function ReviewPage({
	additionalTools,
	articles,
	backgroundImage,
	coreOfferings,
	hasVwo,
	meta = {
		canonical: 'https://www.business.com',
		description: 'Get the business advice, tips, and resources you need to run and grow your business.',
		ogImage: 'https://www.business.com/images/branding/logos/block_monogram_navy.jpg',
		robots: 'index, follow',
		title: 'business.com: Expert Business Advice, Tips, and Resources',
	},
	methodology,
	priceQuotes,
	categories,
	subtitle,
	testimonials,
	title,
}) {
	return (
		<ReviewPageWrapper>
			<Layout boxSizing="content-box" hasVwo={hasVwo} isOverlappingHero={true} meta={meta}>
				<HeroBanner
					background={backgroundImage}
					overlayColor="#000000"
					overlayOpacity=".30"
					bgPosition="70%"
					maxBgPosition="0 30%"
					height="65vh"
				>
					<ReviewBannerTitle>{title}</ReviewBannerTitle>
					<ReviewBannerText>{subtitle}</ReviewBannerText>
					<SearchForm
						color="#ffffff"
						queryString="&t=review&s=0&d=0"
						redirectUrl="/search/?q=reviews&t=category&s=0&d=0"
					/>
				</HeroBanner>
				<OfferingsMethhWrapper>
					<CoreOfferings coreOfferings={coreOfferings} />
					<Methodology {...methodology} />
				</OfferingsMethhWrapper>
				<ReviewCards reviews={categories} />
				<PriceQuotes {...priceQuotes} />
				<Testimonials {...testimonials} />
				<AdditionalTools {...additionalTools} relatedArticles={articles} />
			</Layout>
		</ReviewPageWrapper>
	)
}
export default ReviewPage
